import { exportHack } from '../../utils/exportHack';
import { footerReverseAtSizes, footerStackAtSizes, footerTypes, sizes, } from './constants';
import { Modal, } from './Modal';
import { ModalBody, } from './ModalBody';
import { ModalFooter, ModalFooterPrimary, ModalFooterSecondary, } from './ModalFooter';
import { ModalHeader, } from './ModalHeader';
const ExportHackModal = (exportHack({
    component: Modal,
    constants: {
        Body: ModalBody,
        Footer: (exportHack({
            component: ModalFooter,
            constants: {
                Primary: ModalFooterPrimary,
                Secondary: ModalFooterSecondary,
            },
        })),
        footerReverseAtSizes,
        footerStackAtSizes,
        footerTypes,
        Header: ModalHeader,
        sizes,
    },
}));
export { ExportHackModal as Modal, ModalBody, ModalFooter, ModalFooterPrimary, ModalFooterSecondary, ModalHeader, };
